export const FLOW_NAME = "impact-analysis-binary";
export type FLOW_TYPE = "impact-analysis-binary";

export const INPUT_DATA = "data";

export const Y_FILTERS_KEY = "y-filters";
export const Y_TAG_ONES = "y-tag-ones";
export const Y_TAG_ZEROS = "y-tag-zeros";

export const TREATMENT_FILTERS_KEY = "treatment-filters";
export const TREATMENT_TAG = "treatment_tag";
export const CONTROL_TAG = "control_tag";

export const TIME_VARIABLE_KEY = "time";
export const ID_VARIABLES_KEY = "id-vars";

export const RECIPE =
  "under-what-conditions-is-a-success-rate-higherlower-in-treatment-than-control-and-by-how-much";

export const ALGOS = ["kl-uplift-tree"];

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";
